import type { AgentReport, AgentCheckResult } from './AgentResult';
import type { Bulletin } from '@shared/types/Bulletin';
import type { Ecriture } from '@shared/types/Ecriture';
import { BalanceService } from '@domain/comptabilite/BalanceService';

/**
 * Agent Coherence : controle la coherence transversale des donnees du tenant.
 */
export class AgentCoherence {
  static readonly NAME = 'Coherence et conformite';

  static run(bulletins: readonly Bulletin[], ecritures: readonly Ecriture[]): AgentReport {
    const start = performance.now();
    const r: AgentCheckResult[] = [];

    // Coherence des bulletins
    const bulletinsKO = bulletins.filter((b) => {
      const somme =
        b.cnss_pf_emp +
        b.cnss_rp_emp +
        b.cnss_vid_emp +
        b.cnamgs_emp +
        b.cnamgs_fam_emp +
        b.cfp_emp +
        b.fnh_emp;
      return Math.abs(somme - b.total_charges_emp) > 1;
    });
    r.push(
      bulletinsKO.length === 0
        ? {
            test: 'Bulletins : total_charges_emp = somme',
            level: 'ok',
            msg: `${bulletins.length} bulletins coherents`,
          }
        : {
            test: 'Bulletins : total_charges_emp = somme',
            level: 'fail',
            msg: `${bulletinsKO.length} bulletins incoherents`,
          },
    );

    // Equilibre des ecritures par periode
    const periodes = [...new Set(ecritures.map((e) => e.periode))];
    let periodesKO = 0;
    for (const p of periodes) {
      const balPeriode = BalanceService.calculer(ecritures.filter((e) => e.periode === p));
      if (!BalanceService.estEquilibree(balPeriode)) periodesKO++;
    }
    r.push(
      periodesKO === 0
        ? {
            test: 'Ecritures equilibrees par periode',
            level: 'ok',
            msg: `${periodes.length} periodes equilibrees`,
          }
        : {
            test: 'Ecritures equilibrees par periode',
            level: 'fail',
            msg: `${periodesKO} periodes desequilibrees`,
          },
    );

    return { agentName: this.NAME, results: r, durationMs: performance.now() - start };
  }
}
